import { useMutation } from 'react-query';
import { get, getWithHeaders } from 'Core/utils/platformApi';
import { PROVIDER_SYNC_CONFIG } from 'Modules/financing/config/providerSyncConfig';

const wait = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

const hasCartLink = (data) => Boolean(data?.next_action && data?.payload?.links?.cart);

// Refreshes the application from the provider and polls GET /application for the result.
// Resolves with the refreshed application, or null if it is not ready before the timeout.
// isReady decides which GET /application response counts as the refreshed application.
async function syncApplication(isReady) {
  const { timeoutMs, intervalMs } = PROVIDER_SYNC_CONFIG;
  const {
    headers: { request_id },
  } = await getWithHeaders('/financing/provider-sync');
  if (!request_id) {
    return null;
  }

  const attempts = Math.floor(timeoutMs / intervalMs);
  for (let attempt = 1; attempt <= attempts; attempt++) {
    await wait(intervalMs);
    const data = await get('/application', { headers: { request_id } });
    if (isReady(data)) {
      return data;
    }
  }
  return null;
}

export default function useProviderSync({ isReady = hasCartLink } = {}) {
  return useMutation(() => syncApplication(isReady).catch(() => null));
}
